/**
 * ScenarioProjectionsAccountant - For accountant portal users
 * 
 * This is a thin wrapper around ScenarioProjectionsBase that handles
 * authentication via AccountantAuthContext.
 */

import React from 'react';
import { useAccountantAuth } from '../contexts/AccountantAuthContext';
import ScenarioProjectionsBase from './ScenarioProjectionsBase';

interface ScenarioProjectionsAccountantProps {
  reportId: string;
  baseResult: any;
}

export default function ScenarioProjectionsAccountant({ reportId, baseResult }: ScenarioProjectionsAccountantProps) {
  const { token } = useAccountantAuth();
  
  return (
    <ScenarioProjectionsBase
      reportId={reportId}
      baseResult={baseResult}
      token={token}
    />
  );
}
